"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const use_form_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));
const Form_1 = __importDefault(require("../../../Form"));
const Button_1 = __importDefault(require("../../../Button"));
const Inline_1 = __importDefault(require("../../../../layouts/Inline"));
const types_1 = require("../../types");
const index_1 = require("../../index");
const FormTemplate = ({ formFields, schema }) => {
    const { handleSubmit, onCancel, onReset } = use_form_api_1.default();
    const { cancelLabel = 'Cancel', canCancel = true, submitLabel = 'Submit', resetLabel = 'Reset', canReset = false, fields, header, description } = schema, rest = __rest(schema, ["cancelLabel", "canCancel", "submitLabel", "resetLabel", "canReset", "fields", "header", "description"]);
    const { isSubmitting } = index_1.useFormRendererContext();
    const actions = (react_1.default.createElement(Inline_1.default, { spacing: "s" },
        canCancel && (react_1.default.createElement(Button_1.default, { variant: "link", onClick: onCancel, disabled: isSubmitting }, cancelLabel)),
        canReset && (react_1.default.createElement(Button_1.default, { variant: "normal", onClick: onReset, disabled: isSubmitting }, resetLabel)),
        react_1.default.createElement(Button_1.default, { variant: "primary", loading: isSubmitting, onClick: (event) => {
                event.preventDefault();
                handleSubmit();
            } }, submitLabel)));
    const actionsVisible = react_1.useMemo(() => {
        return !(fields.length > 0 && fields[0].component === types_1.componentTypes.WIZARD);
    }, [fields]);
    const testId = rest['data-testid'] || 'form-renderer';
    return (react_1.default.createElement(Form_1.default, { header: header, description: description, actions: actionsVisible ? actions : undefined, "data-testid": testId }, formFields));
};
exports.default = FormTemplate;
//# sourceMappingURL=index.js.map